export enum DriverStatus {
  PENDING = 'PENDING',
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
  DELETED = 'DELETED',
}

export const DriverStatusLabels: Record<DriverStatus, string> = {
  [DriverStatus.PENDING]: 'Pendiente',
  [DriverStatus.ACTIVE]: 'Activo',
  [DriverStatus.INACTIVE]: 'Inactivo',
  [DriverStatus.DELETED]: 'Eliminado',
};
